const stats = [
  { icon: "ri-home-2-line", value: "500+", label: "Projects Completed" },
  { icon: "ri-time-line", value: "12+", label: "Years Experience" },
  { icon: "ri-map-pin-2-line", value: "Surrey & London", label: "Areas Covered" },
  { icon: "ri-shield-check-line", value: "10 Year", label: "Guarantee" },
  { icon: "ri-star-fill", value: "4.9/5", label: "Customer Rating" },
];

export default function StatsBar() {
  return (
    <section className="bg-zinc-900 py-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-0 lg:divide-x lg:divide-white/10">
          {stats.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center text-center px-4">
              <div className="w-8 h-8 flex items-center justify-center mb-2">
                <i className={`${stat.icon} text-amber-400 text-xl`}></i>
              </div>
              <span
                className="text-white text-xl font-bold leading-tight"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {stat.value}
              </span>
              <span
                className="text-stone-400 text-xs mt-1"
                style={{ fontFamily: "'Raleway', sans-serif" }}
              >
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
